<app-choose-plan-generic
  [currentPlan]="currentPlan"
  [(payRecurrence)]="payRecurrence"
  (planCardBtnClick)="handlePlanChange($event)"
  [isV2]="isV2"
  [ngClass]="{ 'v2': isV2 }"
></app-choose-plan-generic>
